import { Record } from 'immutable';

const BrowserRecord = Record({
  isWebRTCSupportBrowser: null,
  isScreenSharingExtensionInstalled: null,
});

export default class Browser extends BrowserRecord {}
